export default {"src":"/_next/static/image/public/images/flags/default_flag.4b1929963b9e0714434e49063cf37f9a.svg","height":16,"width":24};